import { useContext } from "react";
import formatDateString from "../../../../../Util/functions/FormatDateString";
import formatTimeString from "../../../../../Util/functions/FormatTimeString";
import LinguisticCompetenceSection from "./LinguisticCompetenceSection";
import PatientCenteredCommunicationSection from "./PatientCenteredCommunicationSection";
import TaskFulfillmentSection from "./TaskFulfillmentSection";
import { AppContext } from "../../../../../Util/contexts/AppContext";
import { wasMoreThanXMinutesAgo } from "../../../../../Util/functions/Timing";
import { getClientTimezoneName } from "../../../../../Util/functions/TimeZone";
import { useState, useEffect } from "react";
const SpeakingGradeSection = ({
  speakingGrade,
  lastChecked,
  resendCaseGrade,
  sectionId,
  resendingGrade,
}) => {
  const { userData } = useContext(AppContext);
  const sentToAITime = new Date(speakingGrade.SentToAITime);
  const hasFeedback =
    speakingGrade.Feedback &&
    speakingGrade.Feedback.grading &&
    Object.keys(speakingGrade.Feedback.grading).length > 0;
  const isInProcess = speakingGrade.state === "in_process";
  const [currentTime, setCurrentTime] = useState(Date.now());

  useEffect(() => {
    if (speakingGrade.state === "processing") {
      const interval = setInterval(() => {
        setCurrentTime(Date.now());
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [speakingGrade.state]);

  const secondsSinceLastCheck = Math.floor(
    (Date.now() - new Date(lastChecked).getTime()) / 1000
  );

  const showResendButton =
    !sentToAITime || wasMoreThanXMinutesAgo(sentToAITime, 20);

  if (speakingGrade.state === "processing") {
    return (
      <div className="gradingFeedbackSectionBodyContainer writingGradeErrorWrapper">
        <div className="gradingFeedbackWaitingForGradeContainer">
          <h2 className="gradingFeedbackWaitingForGradeTitle">
            Grading In Progress
          </h2>
          <p className="gradingFeedbackWaitingForGradeText">
            This section was sent for grading on{" "}
            {formatDateString(
              speakingGrade.SentToAITime,
              userData.TimeZoneOverride
                ? getClientTimezoneName()
                : userData.TimeZone
            )}{" "}
            at{" "}
            {formatTimeString(
              speakingGrade.SentToAITime,
              userData.TimeZoneOverride
                ? getClientTimezoneName()
                : userData.TimeZone
            )}
            . Speaking exams can take 5 or more minutes to be graded. We will
            check for your grade every 20 seconds. This section will populate
            once your exam is graded, or you can check back later.
          </p>
          <p className="gradingFeedbackWaitingForGradeSubtext">
            Last checked for grade {secondsSinceLastCheck} seconds ago
          </p>
          {showResendButton && !resendingGrade && (
            <div>
              <p className="gradingFeedbackWaitingForGradeText">
                Something went wrong <br></br>
                Click below to resend to grade.
              </p>
              <button
                className="tertiaryButton newGradingButton"
                onClick={async () => {
                  await resendCaseGrade("speaking", sectionId);
                }}
              >
                Resend
              </button>
            </div>
          )}
          {resendingGrade && (
            <p className="gradingFeedbackWaitingForGradeText">
              Resending grade...
            </p>
          )}
        </div>
      </div>
    );
  } else if (isInProcess || !hasFeedback) {
    return (
      <div className="gradingFeedbackSectionBodyContainer writingGradeErrorWrapper">
        <div className="gradingFeedbackWaitingForGradeContainer">
          This grade is corrupt and unavailable.{" "}
          {isInProcess
            ? "Grade is marked as in process. This is an error. Please check back soon or contact us about this grade."
            : "Grade exists but contains no data. Please refresh your application. If this does not work, please contact us about this grade."}
        </div>
      </div>
    );
  }

  const gradeDetails = speakingGrade.Feedback.grading;

  const linguisticCompetence = gradeDetails["linguistic_competence"];
  const patientCenteredCommunication =
    gradeDetails["patient_centered_communication"];
  const taskFulfillment = gradeDetails["task_fulfillment"];

  return (
    <>
      <div className="gradingFeedbackSectionBodyContainer writingGradeSectionWrapper">
        <LinguisticCompetenceSection
          linguisticCompetence={linguisticCompetence}
        />
        <PatientCenteredCommunicationSection
          patientCenteredCommunication={patientCenteredCommunication}
        />
        <TaskFulfillmentSection taskFulfillment={taskFulfillment} />
      </div>
    </>
  );
};

export default SpeakingGradeSection;
